export default __webpack_public_path__ + "static/media/2-Cloudxier-DailyCaffeine.66bded86.jpg";